import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

@Injectable()
export class TermsConditionsServiceProvider {

  constructor(
    public http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
  ) {

  }

  allDocuments(){
    return new Promise((resolve, reject) => {
      this.http.get(`/terms-conditions`).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
      );
    });
  }

  getRegisterCustomer() {
    return new Promise((resolve, reject) => {
      this.http.get(`/terms-conditions/register-customer`).subscribe(
        (url: any) => {
          resolve(url);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
      );
    });
  }

  getInviteBarbershop() {
    return new Promise((resolve, reject) => {
      this.http.get(`/terms-conditions/invite-barbershop`).subscribe(
        (url: any) => {
          resolve(url);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
      );
    });
  }

  getPrivacyPolicy() {
    return new Promise((resolve, reject) => {
      this.http.get(`/terms-conditions/privacy-policy`).subscribe(
        (url: any) => {
          resolve(url);
        },
        (error) => {
          this.apiErrorHandler.handleError(error);
          reject(error);
        },
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/terms-conditions-service/terms-conditions-service.ts